import * as types from './contador.actionTypes';
import * as commonActionType from '@common/store/common/common.actionsType';
import store from '@common/store/store';
import Immutable from 'seamless-immutable';

const initialState = Immutable({

});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload || {};
  switch (action.type) {
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule('mobiliario.cadastro.contador', reduce);
